import { MILESTONE_DEFINITIONS_ACTION_TYPE } from '../actions';

const initialState = {};

const milestoneDefinitionsSchemaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MILESTONE_DEFINITIONS_ACTION_TYPE.GET_MILESTONE_DEFINITIONS_SCHEMA:
      return payload || state;

    default:
      return state;
  }
};

export default milestoneDefinitionsSchemaReducer;
